// in myRestProvider.js
import { stringify } from "query-string";
import {
  GET_LIST,
  GET_ONE,
  CREATE,
  UPDATE,
  // UPDATE_MANY,
  DELETE,
  DELETE_MANY,
  GET_MANY,
  GET_MANY_REFERENCE
} from "react-admin";

import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from "./common/common";

const apiUrl = RUN_TIME_API_ENDPOINT;

const convertFileToBase64 = file =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);

    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

/**
 * Maps react-admin queries to my REST API
 *
 * @param {string} type Request type, e.g GET_LIST
 * @param {string} resource Resource name, e.g. "posts"
 * @param {Object} payload Request parameters. Depends on the request type
 * @returns {Promise} the Promise for a data response
 */
export default async (type, resource, params) => {
  if ("data" in params) {
    // convertFileToBase64(params.data.profile_data).then(image_data => {
    //     params.data.profile_data = image_data;
    //     console.log('options.body',  JSON.stringify(params.data));
    //     options.body = JSON.stringify(params.data);
    // });
    if ("profile_data" in params.data) {
      if (
        typeof params.data.profile_data !== "string" &&
        params.data.profile_data != null
      ) {
        const image_data = await convertFileToBase64(params.data.profile_data);
        params.data.profile_data = image_data;
      }
    }
    if ("image_data" in params.data) {
      if (
        typeof params.data.image_data !== "string" &&
        params.data.image_data != null
      ) {
        const image_data = await convertFileToBase64(params.data.image_data);
        params.data.image_data = image_data;
      }
    }
    if ("banner_data" in params.data) {
      if (
        typeof params.data.banner_data !== "string" &&
        params.data.banner_data != null
      ) {
        const image_data = await convertFileToBase64(params.data.banner_data);
        params.data.banner_data = image_data;
      }
    }
  }
  const options = CommonHeaderOption();
  let url = "";
  switch (type) {
    /* Prepare url and options as above */
    case GET_LIST: {
      console.log("{resource}", resource);
      url = `${apiUrl}/${resource}`;
      if (params.searchValue) {
        const query = { searchValue: params.searchValue };
        url += `?${stringify(query)}`;
      }
      if (params.pagination || params.sort) {
        const { page, perPage } = params.pagination;
        const { field, order } = params.sort;
        const query = {
          sort: JSON.stringify([field, order]),
          range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
          filter: JSON.stringify(params.filter),
        };
        url += `?${stringify(query)}`;
      }
      break;
    }
    case GET_ONE:
      console.log("resource", resource);
      if (resource === "getSapDetails") {
        url = `${apiUrl}/businesses/${params.id}/${resource}`;
      } else {
        url = `${apiUrl}/${resource}/${params.id}`;
      }

      break;
    case GET_MANY: {
      const query = {
        filter: JSON.stringify({ id: params.ids })
      };
      url = `${apiUrl}/${resource}?${stringify(query)}`;
      break;
    }
    case GET_MANY_REFERENCE: {
      const { field, order } = params.sort;
      const query = {
        sort: JSON.stringify([field, order]),
        filter: JSON.stringify({
          ...params.filter,
          [params.target]: params.id
        })
      };
      url = `${apiUrl}/${resource}?${stringify(query)}`;
      break;
    }
    case UPDATE:
      console.log("apiUrl", apiUrl);
      console.log("update");
      url = `${apiUrl}/${resource}/${params.id}`;
      console.log("url >>>", url);
      options.method = "PATCH";
      options.body = JSON.stringify(params.data);
      break;
    case CREATE:
      url = `${apiUrl}/${resource}`;
      options.method = "POST";
      options.body = JSON.stringify(params.data);
      break;
    case DELETE:
      url = `${apiUrl}/${resource}/${params.id}`;
      options.method = "DELETE";
      break;
    case DELETE_MANY:
      // const query = {
      //     filter: JSON.stringify({ id: params.ids }),
      // };
      url = `${apiUrl}/${resource}/setinactive`;
      options.method = "POST";
      options.body = JSON.stringify({ id: params.ids });
      break;
    default:
      throw new Error(`Unsupported Data Provider request type ${type}`);
  }

  return fetch(url, options)
    .then(res => {
      if (res.status === 401) {
        localStorage.removeItem("__state");
        window.location.href = "#/login";
      }
      return res.json();
    })
    .then(json => {
      console.log('hello json', json.data)
      switch (type) {
        case GET_LIST:
        case GET_MANY_REFERENCE:
          return {
            data: json.data,
            total: json.total
          };
        case CREATE:
          console.log("json", json);
          if (!json.errorMsg) {
            return { data: json };
          } else {
            return Promise.reject({ message: json.errorMsg });
          }
        case DELETE:
          return {
            data: json.data,
            status: json.status
          };
        case UPDATE:
          if (!json.msg || json.msg === "") {
            return {
              data: { ...params.data, id: json.id, status: json.status }
            };
          } else {
            return Promise.reject({ message: json.msg });
          }
        case GET_ONE:
          return {
            data: typeof json.data === "undefined" ? json : json.data
          };
        default:
          return { data: json.data };
      }
    })
    .catch(error => {
      // ALL Error Handling Here
      if (
        error.message !== "" &&
        error.message !== null &&
        error.message !== undefined
      ) {
        return Promise.reject({ message: error.message });
      } else {
        return Promise.reject({
          message: "Somthing Went Wrong. Plase try Again Later"
        });
      }
    });
};
